import React, { useEffect } from 'react';

import CFAnalyticsHeader from 'Deer/components/Develop/CFAnalyticsHeader';
import { getApplicableL2CompanyModules } from 'Deer/components/navigation/secondary/Company/CompanyModules';
import { useRouteToNavLevels } from 'Deer/hooks/useRouteToL3';
import { CompetenciesInsightsIntent } from 'Deer/intent/Competencies/CompetenciesInsightsIntent';
import { CompetenciesIntentDropdown } from 'Deer/intent/Competencies/components/CompetenciesIntentDropdown';
import { Layout } from 'Deer/intent/components/Layout/Layout';
import useOrganisationSettings from 'components/hooks/useOrganisationSettings';
import { useDispatch } from 'react-redux';
import { setSelectedView } from 'reducers/viewsSlice';
import ContinuousFeedbackAnalyticsLandingPage from 'screens/analytics/continuousFeedback/ContinuousFeedbackAnalyticsLandingPage';
import { checkIntentLandingPagesFeatureEnabled } from 'utils/helpers/featureFlags';

import { PageTabbedNavigationV1 } from 'uiToolkitV1/PageTabbedNavigationV1';

interface Props {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  cohort: any;
  headerLabel: string;
}

const CompanyDevelopInsights = ({ cohort, headerLabel }: Props) => {
  const dispatch = useDispatch();
  const { l3Options: tabs } = useRouteToNavLevels();
  const { moduleName } = useOrganisationSettings();
  const applicableL2CompanyModules = getApplicableL2CompanyModules(moduleName) ?? [];

  useEffect(() => {
    dispatch(setSelectedView({ ...cohort, teamId: cohort.id }));
    return () => {
      dispatch(setSelectedView({}));
    };
  }, [cohort]);

  if (checkIntentLandingPagesFeatureEnabled()) {
    return (
      <Layout
        Filters={
          <CompetenciesIntentDropdown
            breadcrumbs={{
              items: [
                {
                  label: 'Company',
                  to: applicableL2CompanyModules[0]?.value,
                },
              ],
              page: {
                label: 'Feedback',
                to: '',
              },
            }}
          />
        }
      >
        <CompetenciesInsightsIntent />
      </Layout>
    );
  }

  return (
    <>
      <CFAnalyticsHeader headerLabel={headerLabel} />
      <PageTabbedNavigationV1 tabs={tabs} />
      <ContinuousFeedbackAnalyticsLandingPage />
    </>
  );
};

export default CompanyDevelopInsights;
